import React from 'react'
import PropTypes from 'prop-types'
import { withAsyncData } from '@/utils/withAsyncData'
import AppForm from './app-form/index'

const AppEdit = ({ id, version }) => {
  return (
    <div data-hook="appEdit">
      <AppForm
        initialAppId={id}
        initialVersion={version}
      />
    </div>
  )
}

AppEdit.propTypes = {
  id: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
}

const fetchData = async({ params }) => {
  return Promise.resolve(params)
}

export default withAsyncData(AppEdit, 'App bearbeiten', fetchData)
